/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Partner BFF
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpResponse,
  http
} from 'msw';
import type {
  RequestHandlerOptions
} from 'msw';

import type {
  HealthStatus
} from '../schemas';

import {
  getGetHealthResponseMock
} from './health.faker';

export { getGetHealthResponseMock } from './health.faker';


export const getGetHealthMockHandler = (overrideResponse?: HealthStatus | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<HealthStatus> | HealthStatus), options?: RequestHandlerOptions) => {
  return http.get('*/api/v1/health', async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {


    return HttpResponse.json(overrideResponse !== undefined
    ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse)
    : getGetHealthResponseMock(),
      { status: 200
      })
  }, options)
}
export const getHealthMock = () => [
  getGetHealthMockHandler()]
